<template>
    <v-layout fill-height column align-center justify-start mx-0>
        <v-card :max-width='$vuetify.breakpoint.smAndUp? "80%": "95%"' :min-width='$vuetify.breakpoint.smAndUp? "80%": "95%"' class = 'my-4' style = 'background: #fff !important; box-shadow: 0 20px 40px 0 rgba(124, 133, 142, 0.1); border-radius: 10px;'>
            <v-card-text class = 'ma-0'>
                <v-item-group v-model='$store.state.signupStep' class='text-xs-center py-1 my-0' mandatory>
                    <v-item v-for='n in $store.state.signupSteps' :key='`btn-${n}`' class = 'mx-4'>
                        <v-btn slot-scope=' { active, toggle } ' :input-value='active' icon small @click=''>
                            <v-icon small :color='active? $store.getters.accentColor: "#e3e3e3"'>{{active? 'mdi-record-circle': 'mdi-record'}}</v-icon>
                        </v-btn>
                    </v-item>
                </v-item-group>
            </v-card-text>
        </v-card>
        <v-card :max-width='$vuetify.breakpoint.smAndUp? "80%": "95%"' :min-width='$vuetify.breakpoint.smAndUp? "80%": "95%"' style = 'background: #fff !important; box-shadow: 0 20px 40px 0 rgba(134, 143, 152, 0.1); border-radius: 10px;'>
            <v-layout column class = 'text-xs-center mt-3 mb-2'>
                <template v-if = '$store.state.signupStep == 0'>
                    <h1 class = 'font-weight-regular'>Welcome to YetVPN.</h1>
                    <p>Get started by creating an account. Already have an account? <a href='javascript:void(0)' @click='$router.push("/signin")' :style='"color:" + $store.getters.accentColor + "; text-decoration: none;"' class='ma-0 pa-0'>Login here</a></p>
                </template>
                <template v-if = '$store.state.signupStep == 1'>
                    <h1 class = 'font-weight-regular'>Choose your YetVPN Plan.</h1>
                    <p>All plans are covered by a no-hassle 100% money-back guarantee for your first 30 days of service.</p>
                </template>
                <template v-if = '$store.state.signupStep == 2'>
                    <h1 class = 'font-weight-regular'>Make your account secure.</h1>
                    <p>You will use this password to log in into account.</p>
                </template>
                <template v-if = '$store.state.signupStep == 3'>
                    <h1 class = 'font-weight-regular'>Account setup {{signupState}}.</h1>
                    <p>{{signupState == "completed"? "You may now log in and start using VPN.": "Please wait for the process to start using VPN."}}</p>
                </template>
            </v-layout>
            <v-window v-model='$store.state.signupStep' touchless style = 'background: linear-gradient(to bottom, rgba(124, 133, 142, 0.1), #fff);'>
                <v-window-item :value='0'>
                    <v-card-text>
                        <v-form 
                          class = 'mx-auto mt-4 pt-4' 
                          v-model='validEmail' 
                          :style = '`width:${$vuetify.breakpoint.smAndUp? "50%": "100%"};`'
                          lazy-validation
                        >
                            <v-text-field :rules="[rules.required]" label="Name" v-model='paymentDetails.firstname' :disabled='userChecking' autofocus outline></v-text-field>
                            <v-text-field 
                              autocomplete='username' 
                              :rules="[rules.required, rules.email]" 
                              label="Email" 
                              v-model='paymentDetails.email' 
                              :error-messages='loginMessages' 
                              :disabled='userChecking' 
                              outline autofocus
                              @blur = 'loginMessages = []'
                              ></v-text-field>
                            <v-layout row mb-4 mt-0 pa-0 align-center>
                                <v-checkbox
                                  hide-details
                                  class = 'ma-0 pa-0'
                                  v-model="policyConfirmed"
                                  label=''
                                ></v-checkbox>
                                <span class = 'caption'>Click here to indicate that you have read and agree to the terms presented in the <a href="https://yetvpn.com/Terms_of_Services.html" target="_blank">Terms and Conditions</a> agreement and <a href="https://yetvpn.com/Privacy_Policy.html" target="_blank">Privacy Policy</a></span>
                            </v-layout>
                            <v-layout row wrap d-flex class = 'mb-4'>
                                <v-btn 
                                  :class = '`mx-0 ${$vuetify.breakpoint.smAndUp? "mr-3": ""}`'
                                  depressed large
                                  @click.prevent='makeAuthByGoogle()'
                                  :style = '`max-width: ${$vuetify.breakpoint.smAndUp? "50%;": "100%; order: 2;"}`'
                                >
                                    <v-icon left small>$vuetify.icons.gcolorized</v-icon>
                                    Signup with Google
                                </v-btn>
                                <v-btn large depressed :disabled='!validEmail || !policyConfirmed' @click='checkEmailOnce()' :loading='stepProcessing' :color='$store.getters.accentColor' class='white--text mx-0'>Continue</v-btn>
                            </v-layout>
                        </v-form>
                    </v-card-text>
                </v-window-item>
                <v-window-item :value='1' style = 'background: linear-gradient(to bottom, rgba(124, 133, 142, 0.1), #fff); border-bottom-right-radius: 10px; border-bottom-left-radius: 10px;'>
                    <v-card-text>
                        <v-container class='grid-list-sm mb-0 pb-0'>
                            <v-layout row wrap>
                                <v-flex xs-6>
                                    <v-card 
                                      hover 
                                      :class = '`${ activeOption == 562090 ? "tariff_card__selected":"tariff_card__default"}`' 
                                      flat
                                      :input-value = 'activeOption'
                                      @click='activeOption = (activeOption == 562090) ? 0: 562090'
                                    >
                                        <v-sheet
                                          class="mx-auto text-xs-center"
                                          elevation="0"
                                          :max-width='`${$vuetify.breakpoint.smAndUp? "45%": "95%"}`'
                                          style = 'position: relative; top: -12px; border-radius: 8px; background: transparent; color: transparent;'
                                        >
                                            <v-flex class = 'py-1'>
                                                <span style = 'font-size: 14px; font-weight: 800;'>Most popular</span>
                                            </v-flex>
                                        </v-sheet>
                                        <v-card-text class='text-xs-center subheading font-weight-light pt-0'>
                                            <v-layout class = 'ma-0 pa-0'>
                                                <v-checkbox 
                                                  :color='$store.getters.accentColor' 
                                                  class = 'ma-0 pa-0' 
                                                  hide-details 
                                                  :value = 'activeOption == 562090'
                                                  off-icon = 'mdi-checkbox-blank-circle-outline'
                                                  on-icon = 'mdi-check-circle-outline'
                                                  :input-value = 'activeOption == 562090'
                                                ></v-checkbox>
                                            </v-layout>
                                            <v-layout class = 'ma-0 pa-0'>
                                                <v-chip class = 'ma-auto' disabled style = 'color: black !important; user-select: none;'>PAY FOR 1-MONTH</v-chip>
                                            </v-layout>
                                            <v-layout 
                                              row class='my-1 py-0' 
                                              :style = '`color: ${activeOption == 562090 ? $store.getters.accentColor: "black"};`'
                                              align-center justify-center
                                            >
                                                <span style = 'opacity: 0.5; font-size: 20px; font-weight: 500; align-self: flex-start;' class = 'pt-2'>$</span>
                                                <span style = 'font-size: 40px; font-weight: bold;' class = 'mx-1'>6.95</span>
                                                <span style = 'font-size: 20px; font-weight: normal;'>/mo</span>
                                            </v-layout>
                                            <v-layout class='mb-2 py-0' justify-center>
                                                <span class = 'caption'>6.95$ billed every month</span>
                                            </v-layout>
                                            <!--v-layout row class='my-0 py-0'>
                                                <v-chip class = 'mx-auto my-0 caption' disabled :class = 'activeOption == 562090? "tariff_chip__selected": "tariff_chip__default"'>Includes taxes $2.15 @ 18%</v-chip>
                                            </v-layout!-->
                                        </v-card-text>
                                    </v-card>
                                </v-flex>
                                <v-flex xs-6>
                                    <v-card 
                                      hover 
                                      :class = '`${ activeOption == 562092 ? "tariff_card__selected":"tariff_card__default"}`' 
                                      flat
                                      @click='activeOption = (activeOption == 562092) ? 0: 562092'
                                    >
                                        <v-sheet
                                          class="mx-auto white--text text-xs-center"
                                          :color='$store.getters.accentColor'
                                          elevation="1"
                                          :max-width='`${$vuetify.breakpoint.smAndUp? "45%": "95%"}`'
                                          style = 'position: relative; top: -12px; border-radius: 8px;'
                                        >
                                            <v-flex class = 'py-1'>
                                                <span style = 'font-size: 14px; font-weight: 800;'>Save 28%</span>
                                            </v-flex>
                                        </v-sheet>
                                        <v-card-text class='text-xs-center subheading font-weight-light pt-0'>
                                            <v-layout class = 'ma-0 pa-0'>
                                                <v-checkbox 
                                                  :color='$store.getters.accentColor' 
                                                  class = 'ma-0 pa-0' 
                                                  hide-details 
                                                  :value = 'activeOption == 562092'
                                                  off-icon = 'mdi-checkbox-blank-circle-outline'
                                                  on-icon = 'mdi-check-circle-outline'
                                                  :input-value = 'activeOption == 562092'
                                                ></v-checkbox>
                                            </v-layout>
                                            <v-layout class = 'ma-0 pa-0'>
                                                <v-chip class = 'ma-auto' disabled style = 'color: black !important; user-select: none;'>PAY FOR 12-MONTHS</v-chip>
                                            </v-layout>
                                            <v-layout 
                                              row class='my-1 py-0' 
                                              :style = '`color: ${activeOption == 562092 ? $store.getters.accentColor: "black"};`'
                                              align-center justify-center
                                            >
                                                <span style = 'opacity: 0.5; font-size: 20px; font-weight: 500; align-self: flex-start;' class = 'pt-2'>$</span>
                                                <span style = 'font-size: 40px; font-weight: bold;' class = 'mx-1'>4.99</span>
                                                <span style = 'font-size: 20px; font-weight: normal;'>/mo</span>
                                            </v-layout>
                                            <v-layout class='mb-2 py-0' justify-center>
                                                <span class = 'caption'>59.95$ billed every 12 months</span>
                                            </v-layout>
                                            <!--v-layout row class='my-0 py-0'>
                                                <v-chip class = 'mx-auto my-0 caption' disabled :class = 'activeOption == 562092? "tariff_chip__selected": "tariff_chip__default"'>Includes taxes $15.01 @ 18%</v-chip>
                                            </v-layout!-->
                                        </v-card-text>
                                    </v-card>
                                </v-flex>
                                <v-flex xs-6>
                                    <v-card 
                                      hover 
                                      :class = '`${ activeOption == 562091 ? "tariff_card__selected":"tariff_card__default"}`' 
                                      flat
                                      @click='activeOption = (activeOption == 562091) ? 0: 562091'
                                    >
                                        <v-sheet
                                          class="mx-auto white--text text-xs-center"
                                          :color='$store.getters.accentColor'
                                          elevation="1"
                                          :max-width='`${$vuetify.breakpoint.smAndUp? "45%": "95%"}`'
                                          style = 'position: relative; top: -12px; border-radius: 8px;'
                                        >
                                            <v-flex class = 'py-1'>
                                                <span style = 'font-size: 14px; font-weight: 800;'>Save 16%</span>
                                            </v-flex>
                                        </v-sheet>
                                        <v-card-text class='text-xs-center subheading font-weight-light pt-0'>
                                            <v-layout class = 'ma-0 pa-0'>
                                                <v-checkbox 
                                                  :color='$store.getters.accentColor' 
                                                  class = 'ma-0 pa-0' 
                                                  hide-details 
                                                  :value = 'activeOption == 562091'
                                                  off-icon = 'mdi-checkbox-blank-circle-outline'
                                                  on-icon = 'mdi-check-circle-outline'
                                                  :input-value = 'activeOption == 562091'
                                                ></v-checkbox>
                                            </v-layout>
                                            <v-layout class = 'ma-0 pa-0'>
                                                <v-chip class = 'ma-auto' disabled style = 'color: black !important; user-select: none;'>PAY FOR 6-MONTHS</v-chip>
                                            </v-layout>
                                            <v-layout 
                                              row class='my-1 py-0' 
                                              :style = '`color: ${activeOption == 562091 ? $store.getters.accentColor: "black"};`'
                                              align-center justify-center
                                            >
                                                <span style = 'opacity: 0.5; font-size: 20px; font-weight: 500; align-self: flex-start;' class = 'pt-2'>$</span>
                                                <span style = 'font-size: 40px; font-weight: bold;' class = 'mx-1'>5.80</span>
                                                <span style = 'font-size: 20px; font-weight: normal;'>/mo</span>
                                            </v-layout>
                                            <v-layout class='mb-2 py-0' justify-center>
                                                <span class = 'caption'>34.90$ billed every 6 months</span>
                                            </v-layout>
                                            <!--v-layout row class='my-0 py-0'>
                                                <v-chip class = 'mx-auto my-0 caption' disabled :class = 'activeOption == 562091? "tariff_chip__selected": "tariff_chip__default"'>Includes taxes $9.67 @ 18%</v-chip>
                                            </v-layout!-->
                                        </v-card-text>
                                    </v-card>
                                </v-flex>
                            </v-layout>
                            <!--v-layout column justify-start mt-2 style = 'max-width: 420px;' mx-auto>
                                <span class = 'caption pb-1' style = 'letter-spacing: 4px; color: #707070; font-weight: 500; user-select: none;'>CARD NUMBER</span>
                                <v-text-field 
                                  :rules="[rules.required]"
                                  :disabled='activeOption == 0'
                                  autofocus outline
                                  hint = 'Enter 16-digit card number'
                                  placeholder = '1234-5678-9012-3456'
                                  validate-on-blur
                                  hide-details
                                  mask = 'credit-card'
                                  class = 'centered-input'
                                >
                                    <template slot = 'append'>
                                        <v-icon color = '#DCDCDC'>mdi-lock</v-icon>
                                    </template>
                                </v-text-field>
                            </v-layout>
                            <v-layout mt-2 style = 'max-width: 420px;' mx-auto justify-space-between>
                                <v-flex column style = 'max-width: 180px;'>
                                    <span class = 'caption pb-1' style = 'letter-spacing: 4px; color: #707070; font-weight: 500; width: 100%; user-select: none;'>EXPIRY DATE</span>
                                    <v-text-field 
                                      :rules="[rules.required]"
                                      :disabled='activeOption == 0'
                                      hint = 'Enter card expiration month and year'
                                      placeholder = '01/2000'
                                      validate-on-blur
                                      hide-details
                                      class = 'centered-input'
                                      outline
                                      mask = '##/####'
                                    >
                                    </v-text-field>
                                </v-flex>
                                <v-flex column style = 'max-width: 180px;'>
                                    <span class = 'caption pb-1' style = 'letter-spacing: 4px; color: #707070; font-weight: 500; width: 100%; user-select: none;'>CVC</span>
                                    <v-text-field
                                      mask = '###'
                                      :rules = "[rules.required]"
                                      :disabled='activeOption == 0'
                                      hint = 'Enter card secure code'
                                      placeholder = '123'
                                      outline
                                      hide-details
                                      class = 'centered-input'
                                      validate-on-blur
                                    >
                                    </v-text-field>
                                </v-flex>
                            </v-layout!-->
                            <v-layout row align-center justify-center mt-2 style = 'max-width: 420px;' mx-auto>
                                <form 
                                  method = 'post' 
                                  :action = 'payment_provider.form' 
                                  id = 'servhost_payment'
                                  onsubmit = 'window.open("", "payment_popup", "scrollbar=yes,width=600,height=600")'
                                  target = 'payment_popup'
                                  style = 'width: 100%;'
                                >
                                  <input type = 'hidden' name = 'payment' value = 'CC'>
                                  <input type = 'hidden' name = 'lang' value = 'en'>
                                  <input type = 'hidden' name = 'first_name' v-model='paymentDetails.firstname'>
                                  <input type = 'hidden' name = 'email' v-model='paymentDetails.email'>
                                  <input type = 'hidden' name = 'key' :value = 'payment_provider.key'>
                                  <input type = 'hidden' name = 'url' :value = 'payment_provider.return'>
                                  <input type = 'hidden' name = 'data' :value = 'product'>
                                  <input type = 'hidden' name = 'sign' :value = 'signature'>
                                  <input type = 'hidden' name = 'ext1' :value = 'subscriptions[activeOption].period'>
                                  <input type = 'hidden' name = 'ext2' :value = 'subscriptions[activeOption].name'>
                                  <input type = 'hidden' name = 'ext3' :value = 'hubspotVid'>
                                     <v-btn
                                      :color='$store.getters.accentColor' 
                                      large depressed block 
                                      @click='dataLayerEnrich("registration", {"type": "step2", "value": 0}); signPayment();' 
                                      :disabled='activeOption == 0'
                                      class = 'white--text mx-0 px-0'>
                                        Pay {{subscriptions[activeOption].cost}} and continue
                                    </v-btn>
                                </form> 
                            </v-layout>
                        </v-container>
                    </v-card-text>
                </v-window-item>
                <v-window-item :value='2'>
                    <v-card-text v-if='!Object.keys(this.$store.state.user).length' class='mt-4 pt-4 mx-auto' :style = '`width:${$vuetify.breakpoint.smAndUp? "50%": "100%"};`'>
                        <v-btn block depressed outline color='blue darken-4' @click.prevent='currentPassword = generateSecureString(12); showPassword = true; validPassword = true;errorPassword = false;' class='mb-3'>Generate secure password</v-btn>
                        <v-form v-model='validPassword'>
                            <v-text-field :rules="[rules.password]" label="Password" v-model='currentPassword' :append-icon="showPassword ? 'visibility_off' : 'visibility'" @click:append="showPassword = !showPassword" :type="showPassword ? 'text' : 'password'" :error='errorPassword' :error-messages='errorPasswordMessage' @keyup='errorPassword=false;errorPasswordMessage=[];' validate-on-blur outline></v-text-field>
                        </v-form>
                        <v-btn large block depressed :disabled='!validPassword' @click='createSystemUser();dataLayerEnrich("registration", {"type": "step4", "result": "password", "value": 0});' :loading='stepProcessing' color='red lighten-1' class='white--text'>Continue</v-btn>
                    </v-card-text>
                    <v-card-text v-else class='mt-4 pt-4 mx-auto' :style = '`width:${$vuetify.breakpoint.smAndUp? "50%": "100%"};`' >
                        <v-layout column class='mt-3 mb-4'>
                            <span class='subheading font-weight-normal text-xs-center'>Your Google account now associated with the service.</span>
                        </v-layout>
                        <v-btn large block depressed @click='dataLayerEnrich("registration", {"type": "step4", "result": "google", "value": 0}); storeTransaction({ "email": $store.state.user.email }, checkoutInfo); deleteOrder(checkoutInfo.order); createVPNAccount();nextWindow()' :loading='stepProcessing' :color='$store.getters.accentColor' class='white--text'>Continue</v-btn>
                    </v-card-text>
                </v-window-item>
                <v-window-item :value='3'>
                    <v-card-text v-if='Object.keys(checkoutInfo).length && checkoutInfo.status == "SALE"' :style = '`width:${$vuetify.breakpoint.smAndUp? "50%": "100%"};`' class='mt-4 pt-4 mx-auto'>
                        <!--v-layout column>
                            <span class='subheading font-weight-light text-xs-center'>Order details</span>
                            <v-layout row justify-space-between>
                                <b>Order: </b>
                                <span :style='"color:" + $store.getters.accentColor + ";"' class='font-weight-regular'>{{checkoutInfo.checkout.id}}</span>
                            </v-layout>
                            <v-layout row justify-space-between>
                                <b>Status: </b>
                                <span :style='"color:" + $store.getters.accentColor + ";"' class='font-weight-regular'>{{checkoutInfo.checkout.completed ? "Completed":"Pending"}}</span>
                            </v-layout>
                            <v-layout row justify-space-between>
                                <b>Time: </b>
                                <span :style='"color:" + $store.getters.accentColor + ";"' class='font-weight-regular'>{{orderTime}}</span>
                            </v-layout>
                            <v-layout row justify-space-between>
                                <b>Paid period: </b>
                                <span :style='"color:" + $store.getters.accentColor + ";"' class='font-weight-regular'>{{checkoutInfo.product.name}}</span>
                            </v-layout>
                        </v-layout>
                        <v-divider class='my-1'></v-divider>
                        <v-layout v-if='currentPassword.length' column>
                            <span class='subheading font-weight-light text-xs-center'>Profile info</span>
                            <v-layout row justify-space-between>
                                <b>Login: </b>
                                <span :style='"color:" + $store.getters.accentColor + ";"' class='font-weight-regular'>{{$store.state.user.email}}</span>
                            </v-layout>
                            <v-layout row justify-space-between>
                                <b>Password: </b>
                                <span :style='"color:" + $store.getters.accentColor + ";"' class='font-weight-regular'>{{currentPassword}}</span>
                            </v-layout>
                        </v-layout>
                        <v-layout v-else>
                            <span class='body-1 font-weight-light'>You can always authorize using google account for this email: {{$store.state.user.email}}</span>
                        </v-layout>
                        <v-divider class='my-1'></v-divider!-->
                        <v-layout column align-center class = 'my-2'>
                            <img src = '@/assets/images/account-creation-success.svg'>
                        </v-layout>
                        <v-btn large block depressed :disabled='vpnCreating' @click='dataLayerEnrich("registration", {"type": "step5", "value": 0}); $router.push("/")' :loading='stepProcessing || vpnCreating' :color='$store.getters.accentColor' class='white--text'>Configure VPN</v-btn>
                    </v-card-text>
                    <v-card-text v-else class='mt-4 pt-4 mx-auto' :style = '`width:${$vuetify.breakpoint.smAndUp? "50%": "100%"};`'>
                        <v-layout column>
                            <v-layout row justify-center>
                                <b>Payment error</b>
                            </v-layout>
                        </v-layout>
                        <v-divider class='my-4'></v-divider>
                        <v-btn large block depressed :color='$store.getters.accentColor' class='white--text' @click='$store.state.signupStep = 1'>Retry</v-btn>
                    </v-card-text>
                </v-window-item>
            </v-window>
        </v-card>
    </v-layout>
</template>
<style>
.v-text-field--outline>.v-input__control>.v-input__slot {
    border-radius: 8px !important;
    border-width: 1px !important;
}
.tariff_card__default {
    border-radius: 10px; 
    border: 2px solid #e9ebf0 !important;
}
.tariff_card__selected {
    border-radius: 10px; 
    border: 2px solid #ee4540 !important;
}
.tariff_chip__selected {
    color: #ee4540 !important; 
    user-select: none; 
    background: #fef5f5 !important;
}
.tariff_chip__default {
    color: black !important; 
    user-select: none;
}
.centered-input input {
    vertical-align: middle;
    line-height: 50% !important;
    margin: auto;
}
</style>
<script>
import aeng from '@/components/auth_engine'
import umeta from '@/components/user_meta'
import vpn from '@/components/vpn'
import payments from '@/components/payments'
import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore'
import md5 from 'md5'

export default {
    path: '/signup',
    name: 'Signup',
    mixins: [aeng, umeta, vpn, payments],
    data() {
        return {
            paymentDetails: {
                email: ''
            },
            completedChecks: 0,
            hubspotUser: {},
            orderDetails: {},
            checkoutInfo: {},
            orderTime: '',
            orderErrors: {},
            policyConfirmed: false,
            vpnCreating: false,
            userChecking: false,
            stepProcessing: false,
            validEmail: true,
            validPassword: true,
            validPaymentDetails: false,
            activeOption: 562092,
            currentPassword: '',
            showPassword: false,
            errorPassword: false,
            errorPasswordMessage: [],
            loginMessages: [],
            subscriptions: {
              '562091': {
                'cost': '34.90 $',
                'name': '6-months subscription',
                'description': 'YetVPN 6 months ($5.80 per month)',
                'period': 6
              },
              '562092': {
                'cost': '59.95 $',
                'name': '12-months subscription',
                'description': 'YetVPN 12 months ($4.99 per month)',
                'period': 12
              },
              '562090': {
                'cost': '6.95 $',
                'name': '1-month subscription',
                'description': 'YetVPN monthly',
                'period': 1
              }
            },
            subscriptionCosts: {
                '562091': '34.90 $',
                '562092': '59.95 $',
                '562090': '6.95 $'
            },
            subscriptionNames: {
                '562091': '6 months',
                '562092': '12 months',
                '562090': '1 month'
            },
            payment_provider: {
              key: 'CB8YYDHE95',
              form: 'https://secure.servhost.online/payment/auth',
              return: 'https://utils.yetvpn.com/vpn/payment/finish'
            },
            signature: ''
        }
    },
    methods: {
        reverseString(str) {
          return str.split('').reverse().join('')
        },
        handleCheckoutSuccess(data) {
            this.checkoutInfo = data;
            this.dataLayerEnrich("registration", { "type": "step3", "result": "success", 'value': this.checkoutInfo.amount })
            let newUser = {
                email: this.paymentDetails.email,
                vid: this.hubspotVid
            };
            this.saveUser(newUser).then((u) => {
                this.nextWindow();
            }).catch((err) => {
                console.log(err)
            });
        },
        handleCheckoutError(data) {
            console.log('error with:', data);
            this.checkoutInfo = data;
            this.dataLayerEnrich("registration", { "type": "step3", "result": "error", 'value': 0 })
        },
        createSystemUser() {
            this.stepProcessing = true;
            this.createNewUserByEmail(this.paymentDetails.email, this.currentPassword).then((u) => {
                this.stepProcessing = false;
                firebase.auth().currentUser.updateProfile({
                    displayName: this.paymentDetails.firstname,
                    photoURL: 'https://www.purevpn.com/images/favicon-96x96.png'
                }).then(() => {
                    this.makeAuthByPwd(this.paymentDetails.email, this.currentPassword);
                    this.updateUser({ 'email': this.$store.state.user.email }, {
                      email: this.checkoutInfo.email,
                      vid: this.hubspotVid,
                      paymentId: this.checkoutInfo.id,
                      uid: firebase.auth().currentUser.uid
                    });
                    this.storeCredentials(this.paymentDetails.email, this.currentPassword);
                    this.storeTransaction({ 'email': this.$store.state.user.email }, this.checkoutInfo);
                    this.deleteOrder(this.checkoutInfo.order)
                    this.createVPNAccount();
                }).catch((err) => { console.log(err) });;
                this.nextWindow();
            }).catch((err) => {
                console.log(err)
                this.stepProcessing = false;
                let errorCode = err.code;
                let errorMessage = err.message;
                if (errorCode == 'auth/email-already-in-use') {
                    this.errorPassword = true;
                    this.errorPasswordMessage = 'User already exists for selected email. Please <a href = "/signin">log in</a>.'
                }
                if (errorCode == 'auth/weak-password') {
                    this.errorPassword = true;
                    this.errorPasswordMessage = 'Provided password is too weak. Please provide more secure string.'
                }
            });
        },
        checkEmailOnce() {
            this.completedChecks += 1;
            if (this.completedChecks > 3) return
            this.stepProcessing = true;
            this.appdb.collection('users').doc(this.paymentDetails.email).get().then((doc) => {
                if (!doc.exists) {
                    this.dataLayerEnrich('registration', {
                        'type': 'step1',
                        'value': 0
                    });
                    if (!Object.keys(this.hubspotUser).length) {
                        let user = {
                            'email': this.paymentDetails.email,
                            'lastname': this.paymentDetails.lastname || '',
                            'firstname': this.paymentDetails.firstname
                        }
                        this.createHubspotUser(user).then((r) => {
                            this.stepProcessing = false;
                            if (r.body.result) {
                                this.hubspotUser = r.body.data;
                                this.nextWindow();
                            } else {
                              console.log(r.body.data)
                            }
                        }, (r) => {
                            this.stepProcessing = false;
                            if (r.body.result) {
                                this.hubspotUser = r.body.data;
                                this.nextWindow();
                            } else {
                              let hspotError = r.body.data;
                              if (hspotError.status == 'error') {
                                this.loginMessages.push(hspotError.validationResults[0].message)
                              }
                            }
                        });
                    } else {
                        this.stepProcessing = false;
                        console.log('no hubspot')
                        this.nextWindow();
                    }
                } else {
                    this.checkAccountExistance(this.paymentDetails.email).then((p) => {
                        this.stepProcessing = false;
                        if (p && p.length > 0) {
                            this.loginMessages.push('User already exists for selected email. Please <a href = "/signin">log in</a>.')
                        } else {
                            let user = {
                                'email': this.paymentDetails.email,
                                'lastname': this.paymentDetails.lastname || '',
                                'firstname': this.paymentDetails.firstname
                            }
                            this.createHubspotUser(user).then((r) => {
                                if (r.body.result) {
                                    this.stepProcessing = false;
                                    this.hubspotUser = r.body.data;
                                }
                            }, (r) => {
                                if (r.body.result) {
                                    this.stepProcessing = false;
                                    this.hubspotUser = r.body.data;
                                }
                            });
                            this.$store.commit('setSignupStep', 2);
                            this.checkoutInfo = {
                                checkout: {
                                    completed: true,
                                    id: 1
                                },
                                product: {
                                    name: 'YetVPN'
                                }
                            }
                        }
                    });
                }
            });
        },
        nextWindow() {
            this.$store.dispatch('addSignup');
        },
        prevWindow() {
            this.$store.dispatch('subSignup');
        },
        createVPNAccount() {
            this.vpnCreating = true;
            this.appdb
                .collection('users').doc(this.$store.state.user.email || this.paymentDetails.email)
                .collection('grants').get().then((qs) => {
                    if (!qs.length) {
                        this.createAccount().then((r) => {
                          this.vpnCreating = false;
                            let today = new Date();
                            let dd = today.getDate();
                            let mm = today.getMonth() + 1;
                            let yyyy = today.getFullYear();
                            if (dd < 10) {
                                dd = '0' + dd
                            }
                            if (mm < 10) {
                                mm = '0' + mm
                            }
                            this.orderTime = dd + '.' + mm + '.' + yyyy
                            if (r.body.result) {
                                this.updateHubspotUser(this.hubspotVid, {
                                    'iscustomer': true,
                                    'registration_form': 'website_v1',
                                    'currency': 'USD',
                                    'plan': this.checkoutInfo.ext1,
                                    'price': this.checkoutInfo.amount,
                                    'first_payment': this.orderTime
                                }).then((hs) => {
                                    this.addUserGrants({ 'email': this.$store.state.user.email }, r.body.data);
                                    if (hs.body.result) {
                                        this.hubspotUser = hs.body.data;
                                    }
                                });
                            }
                        });
                    } else {
                        console.log(qs)
                    }
                });
        },
        signPayment() {
          let doNothing = true;
          /*this.composeSignature(this.product).then( (r) => {
            if (r.body.result) {
              this.signature = r.body.data;
              document.querySelector('#servhost_payment input[name="sign"]').value = this.signature
              document.querySelector('#servhost_payment input[name="ext1"]').value = this.subscriptions[this.activeOption].period
              document.querySelector('#servhost_payment input[name="ext2"]').value = this.subscriptions[this.activeOption].name
              document.querySelector('#servhost_payment input[name="ext3"]').value = this.hubspotVid
              document.querySelector('#servhost_payment').submit()
            }
          })*/
        }
    },
    computed: {
        product() {
          return btoa(JSON.stringify({
            //'amount': this.subscriptionCosts[this.activeOption].replace(' $', ''),
            'amount': this.subscriptions[this.activeOption].cost.replace(' $', ''),
            'currency': 'USD',
            'description': this.subscriptions[this.activeOption].description,
            'recurring': 'recurring'
          }))
        },
        signupState() {
          return (this.stepProcessing || this.vpnCreating) ? 'in progress':'completed'
        },
        activeRegistrant() {
            return this.$store.getters.getRegistrant;
        },
        hubspotVid() {
            let vid = this.hubspotUser['identity-profiles'] &&
                this.hubspotUser['identity-profiles'][0] &&
                this.hubspotUser['identity-profiles'][0]['vid']
              let vid2 = this.hubspotUser && this.hubspotUser.identityProfile && this.hubspotUser.identityProfile.vid
            return vid || vid2
        }
    },
    watch: {
        activeRegistrant(value) {
            this.paymentDetails.email = this.paymentDetails.email || value.email;
            this.paymentDetails.firstname = this.paymentDetails.firstname || value.firstname;
            this.paymentDetails.lastname = this.paymentDetails.lastname || value.lastname;
            this.checkEmailOnce()
        }
    },
    mounted() {
        this.initApp();
        this.initPGW();
        var that = this;
        var fired = false;
        window.addEventListener('message', function(event) {
          if (event.data.event == 'payment_processed' && !fired) {
            fired = true;
            that.describeOrder(event.data.order_id).then( (r) => {
              if (r.body.data.status == 'SALE') {
                that.handleCheckoutSuccess(r.body.data);
              } else {
                that.handleCheckoutError(r.body.data)
              }
            });
          }
        });
        if (Object.keys(this.$route.query).includes('vid')) {
            this.getHubspotUser(this.$route.query.vid).then((r) => {
                if (r.body.result) {
                    this.hubspotUser = r.body.data;
                    this.$store.dispatch('updateRegistrationInfo', {
                        email: r.body.data.properties['email'].value,
                        firstname: r.body.data.properties['firstname'] && r.body.data.properties['firstname'].value,
                        lastname: r.body.data.properties['lastname'] && r.body.data.properties['lastname'].value
                    });
                }
            });
        }
        this.deactivateAuth()
        this.$store.dispatch('initSignup');
    }
}
</script>